import ColorPicker from './src/ColorPicker.vue';
import { withInstall } from '../../utils';
export const ColorPickerV3 = withInstall(ColorPicker);
export default ColorPickerV3;
